// Libraries
import React from "react";
import { Link } from "react-router-dom";

const FolderName = ({ name }) => {
  return (
    <Link title={name} to={`/dashboard/files?folder=${name}`}>
      <i
        className="bx bxs-folder bx-sm"
        style={{ verticalAlign: "bottom" }}
      ></i>{" "}
      <span>{name}</span>{" "}
    </Link>
  );
};

export default FolderName;
